module.exports = __webpack_public_path__ + "img/icon-history-active.d30d2449.svg";